import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    quantity: {
      label: {
        id: 'relativeDate.properties.quantity',
        defaultMessage: 'Quantity',
        description: 'Label of the relative date field quantity',
      },
    },
    type: {
      label: {
        id: 'relativeDate.properties.type',
        defaultMessage: 'Type',
        description: 'Label of the relative date field type',
      },
    },
    dayOfWeek: {
      label: {
        id: 'relativeDate.properties.dayOfWeek',
        defaultMessage: 'Day of week',
        description: 'Label of the relative date field quantity',
      },
    },
    dayOfMonth: {
      label: {
        id: 'relativeDate.properties.dayOfMonth',
        defaultMessage: 'Day of month',
        description: 'Label of the relative date field quantity',
      },
    },
    time: {
      label: {
        id: 'relativeDate.properties.time',
        defaultMessage: 'Time',
        description: 'Label of the relative date field time',
      },
    },
  },
  dateTypeOptions: {
    minutes: {
      id: 'relativeDate.dateTypeOptions.minutes',
      defaultMessage: 'Minutes',
      description: 'Label of the date type option minutes',
    },
    hours: {
      id: 'relativeDate.dateTypeOptions.hours',
      defaultMessage: 'Hours',
      description: 'Label of the date type option hours',
    },
    days: {
      id: 'relativeDate.dateTypeOptions.days',
      defaultMessage: 'Days',
      description: 'Label of the date type option days',
    },
    weeks: {
      id: 'relativeDate.dateTypeOptions.weeks',
      defaultMessage: 'Weeks',
      description: 'Label of the date type option weeks',
    },
    months: {
      id: 'relativeDate.dateTypeOptions.months',
      defaultMessage: 'Months',
      description: 'Label of the date type option months',
    },
  },
};

export default defineMessages(translations);
